export default function Toggle({ checked, onChange, disabled = false, ...restProps }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full shadow transition-colors focus:outline-none ${checked ? "bg-primary-dark" : "bg-white"
        } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
      {...restProps}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full shadow mt-[2px] ring-0 transition ${
          checked ? "translate-x-5 bg-white" : "translate-x-1 bg-gray-200"
        }`}
        style={{ backgroundColor: "white"}}
      />
    </button>
  );
}
